import {
  createClient,
  DeleteOperation,
  deleteRequestFactory,
  FindOperation,
  getRequestFactory,
  postRequestFactory,
  putRequestFactory,
  SaveOperation,
  SearchOperation,
  searchRequestFactory
} from '@infuse/api/common';
import { NewTokenGroup, OcpiLocation, Token, TokenGroup, UpdateTokenGroup } from './model';

const client = createClient('/rest/token-group');

export const tokenGroupPermissions = {
  SEARCH: 'cpms.search-token-groups',
  GET: 'cpms.get-token-group',
  CREATE: 'cpms.create-token-group',
  UPDATE: 'cpms.update-token-group',
  DELETE: 'cpms.delete-token-group',
  SEARCH_LOCATIONS: 'cpms.search-token-group-locations',
  SEARCH_TOKENS: 'cpms.search-token-group-tokens',
  ADD_LOCATIONS: 'cpms.add-token-group-locations',
  ADD_TOKENS: 'cpms.add-token-group-tokens',
  DISABLE: 'cpms.disable-token-group',
  ENABLE: 'cpms.enable-token-group',
  REMOVE_TOKEN_GROUP_LOCATIONS: 'cpms.remove-token-group-locations',
  REMOVE_TOKEN_GROUP_TOKENS: 'cpms.remove-token-group-tokens'
};

export const searchTokenGroups: SearchOperation<TokenGroup> = searchRequestFactory<TokenGroup>(client, {
  pattern: '',
  permissionId: tokenGroupPermissions.SEARCH
});
export const getTokenGroup: FindOperation<TokenGroup, string> = getRequestFactory<TokenGroup, string>(client, {
  permissionId: tokenGroupPermissions.GET
});
export const createOcpiTokenGroup: SaveOperation<NewTokenGroup> = postRequestFactory<NewTokenGroup, TokenGroup>(
  client,
  {
    pattern: '',
    permissionId: tokenGroupPermissions.CREATE
  }
);
export const updateOcpiLocalTokenGroup: SaveOperation<UpdateTokenGroup> = putRequestFactory<
  UpdateTokenGroup,
  TokenGroup,
  string
>(client, { pattern: '/{tokenGroupId}', permissionId: tokenGroupPermissions.UPDATE });
export const deleteOcpiLocalTokenGroup: DeleteOperation<void> = deleteRequestFactory<void, string>(client, {
  permissionId: tokenGroupPermissions.DELETE
});

export const searchOcpiTokenGroupPools: SearchOperation<OcpiLocation, object> = searchRequestFactory<
  OcpiLocation,
  object
>(client, {
  pattern: '/{tokenGroupId}/locations',
  permissionId: tokenGroupPermissions.SEARCH_LOCATIONS
});

export const searchOcpiTokenGroupTokens: SearchOperation<Token, object> = searchRequestFactory<Token, object>(client, {
  pattern: '/{tokenGroupId}/tokens',
  permissionId: tokenGroupPermissions.SEARCH_TOKENS
});

// Commands
export interface AddPoolsCommand {
  replace: boolean;
  locationIds: string[];
}

export const addPoolsToOcpiTokenGroup: SaveOperation<AddPoolsCommand, void, string> = postRequestFactory<
  AddPoolsCommand,
  void,
  string
>(client, { pattern: '/{tokenGroupId}/add-locations', permissionId: tokenGroupPermissions.ADD_LOCATIONS });

export interface AddTokensCommand {
  replace: boolean;
  tokenIds: string[];
}

export const addTokensToOcpiTokenGroup: SaveOperation<AddTokensCommand, void, string> = postRequestFactory<
  AddTokensCommand,
  void,
  string
>(client, { pattern: '/{tokenGroupId}/add-tokens', permissionId: tokenGroupPermissions.ADD_TOKENS });

export const disableOcpiTokenGroup: SaveOperation<void, void, string> = postRequestFactory<void, void, string>(client, {
  pattern: '/{tokenGroupId}/disable',
  permissionId: tokenGroupPermissions.DISABLE
});

export const enableOcpiTokenGroup: SaveOperation<void, void, string> = postRequestFactory<void, void, string>(client, {
  pattern: '/{tokenGroupId}/enable',
  permissionId: tokenGroupPermissions.ENABLE
});

export interface RemovePoolsCommand {
  locationIds: string[];
}

export const removePoolsFromOcpiTokenGroup: SaveOperation<RemovePoolsCommand, void, string> = postRequestFactory<
  RemovePoolsCommand,
  void,
  string
>(client, {
  pattern: '/{tokenGroupId}/remove-locations',
  permissionId: tokenGroupPermissions.REMOVE_TOKEN_GROUP_LOCATIONS
});

export interface RemoveTokensCommand {
  tokenIds: string[];
}

export const removeTokensFromOcpiTokenGroup: SaveOperation<RemoveTokensCommand, void, string> = postRequestFactory<
  RemoveTokensCommand,
  void,
  string
>(client, { pattern: '/{tokenGroupId}/remove-tokens', permissionId: tokenGroupPermissions.REMOVE_TOKEN_GROUP_TOKENS });
